import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { VersionOptionDto } from '@/api-sdk';
import { baseStyles } from '@/styles';

@customElement('fg-version-option')
export class FgVersionOption extends LitElement {
  @property({ type: Object })
  option?: VersionOptionDto;

  render() {
    if (!this.option) {
      return null;
    }

    const { version, queryString, selected } = this.option;

    return html`
      <button
        class=${`option ${selected && 'selected'}`}
        @click=${() => this.selectOption(queryString)}
      >
        <span class="option-label">${version}</span>
      </button>
    `;
  }

  selectOption(queryString: VersionOptionDto['queryString']) {
    this.dispatchEvent(
      new CustomEvent('option-selected', {
        composed: true,
        detail: { option: { queryString } },
      }),
    );
  }

  static styles = [
    baseStyles,
    css`
      .option {
        font-size: 1rem;
        font-weight: 700;
        text-align: center;
        min-height: 58px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
        position: relative;
      }

      .option.selected {
        background: var(
          --fg-config-selected--light,
          var(--fg-fallback-config-selected--light)
        );
        border: 2px solid
          var(--fg-config-selected, var(--fg-fallback-config-selected));
        cursor: default;
      }

      .option:not(.selected):hover {
        color: var(--fg-primary, var(--fg-fallback-primary));
        border-color: var(--fg-primary, var(--fg-fallback-primary));
        box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
      }

      .option-label {
        padding: 8px;
      }
    `,
  ];
}
